import { render, staticRenderFns } from "./ComprasCard.vue?vue&type=template&id=cc170dae"
import script from "./ComprasCard.vue?vue&type=script&lang=js"
export * from "./ComprasCard.vue?vue&type=script&lang=js"
import style0 from "./ComprasCard.vue?vue&type=style&index=0&id=cc170dae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports